import config from '../../../config/config';
import getRequest from '../base/get';
import postRequest from '../base/post';

export default {
  /**
   * Fetch eMSP CDR by ID
   * @param {string} id - The CDR ID
   * @returns {Promise<any>} The API response
   */
  fetchEmspCdrById: (id: string): Promise<any> => {
    return getRequest(`${config.emsp.transactionApiUrl}api/emsp/v1/cdrs/${id}`);
  },

  /**
   * Release payment hold on a CDR.
   * @param {string} cdrId - The CDR ID
   * @returns {Promise<any>} The API response
   */
  releasePaymentHold: (cdrId: string): Promise<any> => {
    return postRequest(
      `${config.emsp.transactionApiUrl}api/emsp/v1/cdrs/${cdrId}/payment/release`,
      {},
    );
  },

  /**
   * Capture unpaid amount for a CDR card payment.
   * @param {string} cdrId - The CDR ID
   * @returns {Promise<any>} The API response
   */
  capturePayment: (cdrId: string): Promise<any> => {
    return postRequest(
      `${config.emsp.transactionApiUrl}api/emsp/v1/cdrs/${cdrId}/payment/capture`,
      {},
      false,
      { timeout: 120000 },
    );
  },

  /**
   * Fetch eMSP CDR details by session ID
   * @param {string} sessionId - The session ID
   * @returns {Promise<any>} The API response
   */
  fetchEmspCdrDetailsBySessionId: (sessionId: string): Promise<any> => {
    return getRequest(
      `${config.emsp.transactionApiUrl}api/emsp/v1/cdrs/session/${sessionId}/details`,
    );
  },
};
